export const Tag = ({ children, active = false }) => (
  <span
    className="inline-flex items-center"
    style={{
      fontSize: 12,
      fontWeight: 500,
      letterSpacing: 0.4,
      lineHeight: "120%",
      padding: "7px 14px",
      borderRadius: "var(--radius-pill)",
      border: `1px solid ${active ? "var(--accent-teal)" : "var(--border-default)"}`,
      background: active ? "var(--accent-teal)" : "#fff",
      color: active ? "#fff" : "var(--ink-700)",
    }}
  >
    {children}
  </span>
);
